import React, { ReactElement } from 'react';

import providerContext from '@philips-emr/hpms-provider-commons/lib/context/provider-context';
import { FilterAPI, Panel, Token } from '@philips-emr/tws-components';
import { LayoutAlign, LayoutJustify, Type } from '@philips-emr/tws-constants';
import Controller, { OnDynamicContentRender, OnMount, OnSelectItem } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent, SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';
import { MessageService } from '@philips-emr/tws-core/lib/services';
import { generateUUID } from '@philips-emr/tws-utils';

import { FragmentNames } from '../../codegen';
import { IndicatorsAliases as Aliases } from '../../codegen/constants/aliases/indicators-aliases';
import { Route } from '../../route';
import BaseController from '../BaseController';

interface Indicator {
  pending: string;
  nrSeqProviderIndicator: number;
  nrSeqProvider: number;
  requiresAttachment: string;
  ieTarget: IndicatorValueStatus;
  dsTarget: string;
  nrSeqIndicatorValue: number;
  competence: string;
}

enum IndicatorValueStatus {
  ON_TARGET = 'S',
  OUT_OF_TARGET = 'N',
  INFORM = 'P',
}

@Controller({ fragment: FragmentNames.INDICATORS })
class IndicatorsController extends BaseController {

  @OnMount(Aliases.FILTER_INDICATORS)
  onMountFilter(event: MountEvent): void {
    const api = event.target as FilterAPI;
    const nrSeqProvider = providerContext.getSelectedProvider().nrSeqProvider;
    api.setData({ nrSeqProvider });
  }

  @OnSelectItem(Aliases.DECK_INDICATORS)
  onClickCardVisit(event: SelectItemEvent<Indicator>): void {
    const { nrSeqProviderIndicator } = event.item;
    this.historyService.push(Route.INDICATOR_DETAILS, { nrSeqProviderIndicator });
  }

  @OnDynamicContentRender(Aliases.CARD_INDICATOR)
  onRenderCardTask(event: RenderEvent): void {
    if (event.data) {
      const { data, render } = event;
      const { pending } = data as Indicator;
      if (pending == 'S') {
        render(() : ReactElement  => renderTokenPending());
      }
    }
  }
}

function renderTokenPending(): ReactElement {
  return <Panel className="" uuid={generateUUID()} margin="0 0 0 1.5rem" justifyContent={LayoutJustify.CENTER} alignItems={LayoutAlign.CENTER}>
    <Token value={MessageService.translate('provider.pending')} type={Type.WARNING} />
  </Panel>;
}

export {
  IndicatorsController,
  Indicator,
  renderTokenPending,
  IndicatorValueStatus,
};
